import { objectHasOwnProperty } from '../functions';

const helpers = {
  'concat-list': require('./helpers/concat-list'),
  'concat': require('./helpers/concat'),
  'encode': require('./helpers/encode'),
  'eq': require('./helpers/eq'),
  'for': require('./helpers/for'),
  'iif': require('./helpers/iif'),
  'split': require('./helpers/split'),
};

export default {
  setup: (handlebars) => {
    for (var k in helpers) {
      if (objectHasOwnProperty(helpers, k)) {
        handlebars.registerHelper(k, helpers[k]);
      }
    }
  }
};
